import { useIntercom } from '@zenbusiness/application-commons-intercom';
import Text from '@zenbusiness/common-components/Text';
import Title from '@zenbusiness/common-components/Title';
import PropTypes from 'prop-types';

import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';

import isWebView from '#client/utils/isWebView';

import SharedAsset from '../SharedAsset';

const Container = styled('div')(() => ({
  margin: 36
}));

const ErrorContainer = styled('div')(({ theme }) => ({
  marginTop: 32,
  maxWidth: 800,
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  padding: 8,
  [theme.breakpoints.up('md')]: {
    padding: '32px 34px'
  }
}));

const ErrorBodyContainer = styled('div')(({ theme }) => ({
  maxWidth: 600,
  width: '100%',
  marginBottom: 16,
  '& .MuiLink-root.MuiTypography-h5': {
    ...theme.typography.title_smallBold
  },
  '& .MuiTypography-h5': {
    ...theme.typography.body_extraLargeRegular
  }
}));

const ErrorDog = styled(SharedAsset)(({ theme }) => ({
  height: '100%',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: '374px'
  }
}));

const renderWebLinks = () => {
  if (isWebView) return null;
  return (
    <>
      In the mean time, try&nbsp;
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link component="button" underline="none" variant="h5" color="primary" onClick={window.location.reload} style={{ verticalAlign: 'top' }}>refreshing the page</Link>
      &nbsp;
      or heading
      &nbsp;
      <Link color="primary" underline="none" variant="h5" href="/">back to our homepage</Link>
      .
    </>
  );
};

const Error = (props) => {
  const { requestId } = props;
  const intercom = useIntercom();
  if (intercom) {
    // hide intercom for every page
    intercom.update({ hide_default_launcher: false });
  }

  return (
    <Container>
      <ErrorContainer>
        <ErrorBodyContainer>
          <ErrorDog src="/icon/misc/dashboard-error-page600.svg" height={374} alt="Error page" />
          <Title
            level={1}
            variant="xl"
            gutterBottom
          >
            Oh no!
          </Title>
          <Text
            size="lg"
            gutterBottom
          >
            Something went wrong, but don&apos;t worry &mdash; this issue has been reported to our
            technical team, and we will get to the bottom of it.
            {renderWebLinks()}
          </Text>
        </ErrorBodyContainer>

        {requestId && (
          // fix: it's micro-l, we don't have mapping yet
          <Text
            size="sm"
            color="focus50"
          >
            Error code:&nbsp;
            <code>
              {requestId}
            </code>
          </Text>
        )}

      </ErrorContainer>
    </Container>
  );
};

Error.propTypes = {
  requestId: PropTypes.string
};

Error.defaultProps = {
  requestId: null
};

export default Error;
